/** Match a 3D object name to a production / sampling ID (exact or prefix). */
export function idsMatch(a, b) {
  if (a == null || b == null) return false;
  const x = String(a).trim();
  const y = String(b).trim();
  if (!x || !y) return false;
  if (x === y) return true;
  const xl = x.toLowerCase();
  const yl = y.toLowerCase();
  if (xl === yl) return true;

  const prefixOk = (short, long) => {
    if (!long.startsWith(short)) return false;
    if (long.length === short.length) return true;
    const next = long.charAt(short.length);
    return Number.isNaN(parseInt(next, 10));
  };

  return prefixOk(xl, yl) || prefixOk(yl, xl);
}

export function objectDisplayName(details) {
  if (!details || typeof details !== 'object') return null;
  return (
    details.ObjectName ||
    details.Name ||
    details.StopeID ||
    details.stope_id ||
    details.dev_end_id ||
    details.name ||
    null
  );
}

const GENERIC_OBJECT_NAMES = new Set([
  '',
  'Scene',
  'Group',
  'Object3D',
  'Mesh',
  'Holes',
  'Assays',
  'HolesHighlight',
]);

function rowPickLabel(row) {
  if (!row || typeof row !== 'object') return null;
  const named = objectDisplayName(row);
  if (named) return String(named).trim() || null;
  const hole =
    row.HOLEID ||
    row.HoleID ||
    row.holeID ||
    row.holeid ||
    row.BHID ||
    row.bhid ||
    row.HOLE_ID;
  if (hole != null && String(hole).trim()) return String(hole).trim();
  return null;
}

/** Label for the bottom click-info bar: instance/row name, mesh name, or layer. */
export function pickedObjectLabel(object, instanceId, layerKey) {
  const pickFn = object?.userData?.pickInstance || object?.userData?.pickPoint;
  const id = Number.isInteger(instanceId)
    ? instanceId
    : instanceId == null || instanceId === ''
      ? NaN
      : Math.floor(Number(instanceId));
  const hasInstance = Number.isInteger(id) && id >= 0;
  const row = hasInstance
    ? typeof pickFn === 'function'
      ? pickFn(id)
      : object?.userData?.instancesData?.[id]
    : object?.userData?.displayData || null;
  const fromRow = rowPickLabel(row);
  if (fromRow) return fromRow;

  let node = object;
  while (node) {
    const n = String(node.name || '').trim();
    if (n && !GENERIC_OBJECT_NAMES.has(n)) return n;
    const tagged = node.userData?.mdvLayerKey;
    if (tagged) return String(tagged);
    node = node.parent;
  }
  return layerKey || 'Object';
}
